import { useLayoutEffect, useRef, useState, type ReactNode } from "react";
import styles from "./Stage.module.css";

export const STAGE_W = 860;
export const STAGE_H = 900;

/** A fixed 860×900 drawing area (the mockup's table column), scaled to fit its parent. */
export function Stage({ children }: { children: ReactNode }) {
  const outer = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);
  useLayoutEffect(() => {
    const el = outer.current!;
    const fit = () => setScale(Math.min(el.clientWidth / STAGE_W, el.clientHeight / STAGE_H));
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return (
    <div ref={outer} className={styles.outer}>
      <div
        className={styles.stage}
        style={{ width: STAGE_W, height: STAGE_H, transform: `scale(${scale})` }}
      >
        {children}
      </div>
    </div>
  );
}

/** Seat positions on an ellipse, index 0 at the bottom, then clockwise. */
export function seatPositions(n: number, rx: number, ry: number, cx = 430, cy = 450) {
  return Array.from({ length: n }, (_, i) => {
    const a = ((90 + (360 / n) * i) * Math.PI) / 180;
    return { x: Math.round(cx + rx * Math.cos(a)), y: Math.round(cy + ry * Math.sin(a)) };
  });
}

/** Rotates a seat list so `you` comes first. */
export function fromYou<T extends { id: string }>(seats: T[], you?: string): T[] {
  const i = seats.findIndex((s) => s.id === you);
  return i < 0 ? seats : [...seats.slice(i), ...seats.slice(0, i)];
}
